import { ArgumentError } from "@baseline/common/errors";
import { ClassRef, InterfaceRef } from "@baseline/common/types";
import type { Context } from "./context";


export interface ServiceProvider<C extends Context = Context>
{
    <T>(serviceType: ClassRef<T>, context: C): T;
    <T>(serviceType: InterfaceRef<T>, context: C): T;
}


export namespace ServiceProvider
{
    export function defaultProvider<T>(serviceType: ClassRef<T> | InterfaceRef<T>, context: Context): T
    {
        if (typeof serviceType != "function")
            throw new ArgumentError(`Can't create interface instance '${serviceType.name}'.`);
        return new serviceType(context);
    }
}
